import React, { useMemo } from 'react';
import cn from 'classnames';

import './icon.scss';

interface Props {
    glyph: {
        id: string;
        content: string;
        viewBox: string;
    };
    width?: number | string;
    height?: number | string;
    className?: string;
    styleName?: string;
    onClick?: (event: React.MouseEvent<SVGSVGElement>) => void;
    title?: string;
}

const Icon: React.FC<Props> = ({
    title,
    glyph,
    width = 16,
    height = 16,
    className,
    onClick,
}) => {
    const renderSvg = useMemo(() => {
        if (!glyph) return null;

        return (
            <svg
                width={width}
                height={height}
                viewBox={glyph.viewBox}
                className={cn(className, '__app-Icon')}
                onClick={onClick}
            >
                <use xlinkHref={`#${glyph.id}`} />
            </svg>
        );
    }, [glyph, width, height, className, onClick]);

    if (title) {
        return (
            <div {...{ title }} styleName="title-wr">
                {renderSvg}
            </div>
        );
    }

    return renderSvg;
};

export default Icon;
